export default [
    // about_top
[
    {
        id:1,
        src:"./images/About/Dermatologist.png",
        title:"Dermatologist",   
    }, 
    {
        id:2,
        src:"./images/About/General_physician.png",
        title:"General Physician",
    },
    {
        id:3,
        src:"./images/About/Gastroenterologist.png",
        title:"Gastroenterologist",
    },
    {
        id:4,
        src:"./images/About/Gynecologist.png",
        title:"Gynecologist",
    },
    {
        id:5,
        src:"./images/About/Neurologist.png",
        title:"Neurologist",
    },
    {
        id:6,
        src:"./images/About/Pediatricians.png",
        title:"Pediatricians",
    }
],
// top_doctors
[
    {
        id:1, group_id:1, src:"/images/TopDoctors/doctor1.png", title:"Dr. Alice Green", pretitle:"General physician", avaialable:true, fee:'$35',
        about: "Dr. Alice Green has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:2, group_id:1, src:"/images/TopDoctors/doctor2.png", title:"Dr. Bob White", pretitle:"General physician", avaialable:true, fee:'$40',
        about: "Dr. Bob White has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:3, group_id:2, src:"/images/TopDoctors/doctor3.png", title:"Dr. Clara Black", pretitle:"Gynecologist", avaialable:true, fee:'$50',
        about: "Dr. Clara Black has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:4, group_id:2, src:"/images/TopDoctors/doctor4.png", title:"Dr. Daniel Gray", pretitle:"Gynecologist", avaialable:true, fee:'$55',
        about: "Dr. Daniel Gray has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:5, group_id:3, src:"/images/TopDoctors/doctor5.png", title:"Dr. Eva Brown", pretitle:"Dermatologist", avaialable:true, fee:'$45',
        about: "Dr. Eva Brown has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:6, group_id:3, src:"/images/TopDoctors/doctor1.png", title:"Dr. Frank Blue", pretitle:"Dermatologist", avaialable:true, fee:'$50',
        about: "Dr. Frank Blue has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:7, group_id:4, src:"/images/TopDoctors/doctor2.png", title:"Dr. Grace Yellow", pretitle:"Pediatricians", avaialable:true, fee:'$60',
        about: "Dr. Grace Yellow has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:8, group_id:4, src:"/images/TopDoctors/doctor3.png", title:"Dr. Henry Orange", pretitle:"Pediatricians", avaialable:true, fee:'$65',
        about: "Dr. Henry Orange has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:9, group_id:5, src:"/images/TopDoctors/doctor4.png", title:"Dr. Irene Purple", pretitle:"Neurologist", avaialable:true, fee:'$70',
        about: "Dr. Irene Purple has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    },
    {
        id:10, group_id:6, src:"/images/TopDoctors/doctor5.png", title:"Dr. Jack Pink", pretitle:"Gastroenterologist", avaialable:true, fee:'$75',
        about: "Dr. Jack Pink has a strong commitment to delivering comprehensive medical care, focusing on preventive medicine, early diagnosis, and effective treatment strategies."
    }
]
]
